<template>
  <div class="app-subscription-plan" v-loading="dataLoading">

    <!-- 套餐列表 -->
    <el-table :data="tableData" row-key="id">
      <el-table-column prop="id" label="ID" width="60" />
      <el-table-column prop="productId" label="Product ID" min-width="170" />
      <el-table-column prop="name" label="Name" min-width="100" />
      <el-table-column prop="targetLevel" label="Level" width="90" />
      <el-table-column label="Price (¥)" width="90" align="right">
        <template slot-scope="scope">
          {{ (scope.row.priceCents / 100).toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column label="Duration (days)" width="125" align="center">
        <template slot-scope="scope">
          {{ scope.row.durationDays === 0 ? '∞' : scope.row.durationDays }}
        </template>
      </el-table-column>
      <el-table-column prop="dailyAnalysis" label="Daily Analysis" width="120" align="center" />
      <el-table-column prop="dailyImprove" label="Daily Improve" width="120" align="center" />
      <el-table-column prop="sortOrder" label="Sort" width="65" align="center" />
      <el-table-column label="Active" width="70" align="center">
        <template slot-scope="scope">
          <div class="status-dot" :class="scope.row.isActive ? 'success' : 'danger'" />
        </template>
      </el-table-column>
      <el-table-column label="Updated At" min-width="175">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span style="margin-left: 8px">{{ scope.row.updatedAt | displayTime() }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Action" width="80" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" icon="el-icon-edit" size="small" @click="openDialog(scope.row)" />
        </template>
      </el-table-column>
    </el-table>

    <!-- 编辑对话框 -->
    <el-dialog title="Edit Subscription Plan" :visible.sync="dialogVisible" width="480px" @close="resetForm">
      <!-- 只读信息 -->
      <div class="plan-readonly-info">
        <span class="info-item"><b>Product ID:</b> {{ form.productId }}</span>
        <span class="info-item"><b>Name:</b> {{ form.name }}</span>
        <span class="info-item"><b>Level:</b> {{ form.targetLevel }}</span>
      </div>

      <el-form ref="form" :model="form" :rules="rules" label-width="130px" size="small">
        <el-form-item label="Price (¥)" prop="priceYuan">
          <el-input-number v-model="form.priceYuan" :min="0" :precision="2" :step="1" style="width: 100%" />
        </el-form-item>

        <el-form-item label="Duration (days)" prop="durationDays">
          <el-input-number v-model="form.durationDays" :min="0" :step="1" style="width: 100%" />
          <div class="field-hint">0 = unlimited</div>
        </el-form-item>

        <el-form-item label="Daily Analysis" prop="dailyAnalysis">
          <el-input-number v-model="form.dailyAnalysis" :min="0" :step="1" style="width: 100%" />
        </el-form-item>

        <el-form-item label="Daily Improve" prop="dailyImprove">
          <el-input-number v-model="form.dailyImprove" :min="0" :step="1" style="width: 100%" />
        </el-form-item>
      </el-form>

      <span slot="footer">
        <el-button size="small" @click="dialogVisible = false">Cancel</el-button>
        <el-button type="primary" size="small" :loading="saving" @click="submitForm">Save</el-button>
      </span>
    </el-dialog>


  </div>
</template>

<script>
import {
  fetchAppSubscriptionPlans,
  upsertAppSubscriptionPlan,
} from "@/api/admin";

export default {
  name: "AppTabSubscriptionPlan",
  data() {
    return {
      tableData: [],
      dataLoading: false,
      saving: false,
      dialogVisible: false,
      // 表单数据（仅可编辑字段 + 只读展示字段）
      form: this.defaultForm(),
      rules: {
        priceYuan: [
          { required: true, message: "Price is required", trigger: "blur" },
        ],
        durationDays: [
          { required: true, message: "Duration is required", trigger: "blur" },
        ],
        dailyAnalysis: [
          { required: true, message: "Daily analysis is required", trigger: "blur" },
        ],
        dailyImprove: [
          { required: true, message: "Daily improve is required", trigger: "blur" },
        ],
      },


    };
  },
  mounted() {
    this.active();
  },
  methods: {
    // 默认空表单
    defaultForm() {
      return {
        id: 0,
        productId: "",
        name: "",
        targetLevel: "",
        priceYuan: 0,
        durationDays: 30,
        dailyAnalysis: 0,
        dailyImprove: 0,
        // 保留不可编辑字段用于提交
        sortOrder: 1,
        isActive: true,
      };
    },
    // Tab 激活时调用
    active() {
      this.fetchData();
    },
    fetchData() {
      this.dataLoading = true;
      fetchAppSubscriptionPlans()
        .then((response) => {
          if (response.success) {
            this.tableData = response.result.items || [];
          }
        })
        .finally(() => {
          this.dataLoading = false;
        });
    },
    // 打开编辑对话框
    openDialog(row) {
      // 将 priceCents → priceYuan
      this.form = {
        id: row.id,
        productId: row.productId,
        name: row.name,
        targetLevel: row.targetLevel,
        priceYuan: row.priceCents / 100,
        durationDays: row.durationDays,
        dailyAnalysis: row.dailyAnalysis,
        dailyImprove: row.dailyImprove,
        sortOrder: row.sortOrder,
        isActive: row.isActive,
      };
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate();
      });
    },
    // 重置表单
    resetForm() {
      this.$refs.form && this.$refs.form.resetFields();
    },
    // 提交（仅发送可编辑字段 + id）
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        this.saving = true;

        const payload = {
          id: this.form.id,
          // 可编辑字段
          priceCents: Math.round(this.form.priceYuan * 100),
          durationDays: this.form.durationDays,
          dailyAnalysis: this.form.dailyAnalysis,
          dailyImprove: this.form.dailyImprove,
          // 只读字段，原值透传，防止 API 全量更新时覆盖为空
          name: this.form.name,
          targetLevel: this.form.targetLevel,
          sortOrder: this.form.sortOrder,
          isActive: this.form.isActive,
        };

        upsertAppSubscriptionPlan(payload)
          .then((response) => {
            if (response.success) {
              this.$notify({
                title: "Update successful",
                type: "success",
              });
              this.dialogVisible = false;
              this.fetchData();
            }
          })
          .finally(() => {
            this.saving = false;
          });
      });
    },


  },
};
</script>

<style lang="scss" scoped>
.app-subscription-plan {
  .status-dot {
    width: 10px;
    height: 10px;
    border-radius: 5px;
    display: inline-block;

    &.success {
      background-color: #67c23a;
    }

    &.danger {
      background-color: #f56c6c;
    }
  }

  .plan-readonly-info {
    margin-bottom: 16px;
    padding: 8px 12px;
    background-color: #f5f7fa;
    border-radius: 4px;
    font-size: 13px;
    color: #606266;

    .info-item {
      margin-right: 20px;
    }
  }

  .field-hint {
    font-size: 11px;
    color: #909399;
    line-height: 1.2;
    margin-top: 2px;
  }
}
</style>
